module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_null.b9d34dd8.png";